import React from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import App from './App.jsx'
import './index.css'
import i18n from './i18n'
import { TenantConfigProvider } from './context/TenantConfigContext'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <TenantConfigProvider tenantId={import.meta.env.VITE_TENANT_ID}>
        <App />
      </TenantConfigProvider>
    </I18nextProvider>
  </React.StrictMode>,
)
